import { createTokens } from "@sail/engine";
const duration = createTokens("animation.duration", {
    instant: "0ms",
    xshort: "50ms",
    short: "100ms",
    medium: "150ms",
    long: "300ms",
    $default: "200ms",
    xlong: "400ms"
});
const easing = createTokens("animation.easing", {
    $default: "cubic-bezier(0, .09, .4, 1)",
    standard: "ease-in-out",
    enter: "ease-out",
    exit: "ease-in"
});
const spring = createTokens("animation.spring", {
    gentle: {
        stiffness: 120,
        damping: 14
    },
    snappy: {
        stiffness: 300,
        damping: 20
    },
    bouncy: {
        stiffness: 400,
        damping: 10
    }
});
const stagger = createTokens("animation.stagger", {
    xshort: "30ms",
    short: "50ms",
    medium: "80ms"
});
const scale = createTokens("animation.scale", {
    enter: 0.95,
    subtle: 0.99,
    pressed: 0.98,
    hover: 1.02
});
export const animation = createTokens("animation", {
    duration,
    easing,
    spring,
    stagger,
    scale
});

//# sourceMappingURL=index.js.map